/* eslint-disable max-len */
import React from 'react';

type Props = {
  width?: number;
  height?: number;
};

const Connect = ({ width = 20, height = 20 }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8.01074 9.51172C7.40722 9.5669 6.83364 9.81252 6.3916 10.2178C5.88489 10.6825 5.59093 11.3225 5.59082 12V14.001C5.59092 14.6785 5.8849 15.3185 6.3916 15.7832C6.83099 16.186 7.40046 16.4302 8 16.4873C7.35335 16.4296 6.75087 16.169 6.29688 15.7529C5.78111 15.2801 5.50011 14.6483 5.5 14V12C5.50011 11.3517 5.78111 10.7199 6.29688 10.2471C6.75338 9.82872 7.36002 9.56745 8.01074 9.51172ZM15.3262 9.95898C16.0478 10.4199 16.4999 11.1696 16.5 11.999V14C16.4999 14.6483 16.2189 15.2801 15.7031 15.7529C15.2489 16.1692 14.646 16.4298 13.999 16.4873C14.5989 16.4304 15.1688 16.1862 15.6084 15.7832C16.1151 15.3185 16.4091 14.6785 16.4092 14.001V12C16.4091 11.5524 16.2805 11.1152 16.04 10.7334C15.872 10.4666 15.6538 10.234 15.3994 10.0449C15.3662 10.0202 15.3434 9.99326 15.3311 9.97168C15.3285 9.96726 15.3278 9.96266 15.3262 9.95898Z'
        stroke='#FFFFFF'
        stroke-linecap='round'
        stroke-linejoin='round'
      />

      <path
        d='M6.27246 4.5H11.7275C12.4578 4.50007 13.1614 4.79943 13.6826 5.33691C14.2042 5.87496 14.5 6.60773 14.5 7.375V9.625C14.5 10.3923 14.2042 11.125 13.6826 11.6631C13.1614 12.2006 12.4578 12.4999 11.7275 12.5H9.0166C8.98229 12.4998 8.9541 12.4719 8.9541 12.4375C8.9541 12.4031 8.98229 12.3752 9.0166 12.375H11.7275C12.4436 12.3749 13.1273 12.0816 13.6289 11.5645C14.1301 11.0476 14.4092 10.3495 14.4092 9.625V7.375C14.4092 6.65053 14.1301 5.95237 13.6289 5.43555C13.1273 4.91842 12.4436 4.62507 11.7275 4.625H6.27246C5.55636 4.62507 4.87268 4.91842 4.37109 5.43555C3.86993 5.95237 3.59082 6.65053 3.59082 7.375V9.625C3.59083 10.1048 3.71366 10.5769 3.94727 10.9941C4.10986 11.2845 4.32235 11.5415 4.57422 11.7529C4.66273 11.8272 4.68157 11.8948 4.68164 11.9248C4.68164 11.9455 4.67513 11.9599 4.66992 11.9707C4.41783 11.7853 4.1945 11.5573 4.0127 11.292C3.67963 10.806 3.49982 10.2233 3.5 9.625V7.375C3.5 6.60773 3.79576 5.87496 4.31738 5.33691C4.83858 4.79943 5.54223 4.50007 6.27246 4.5Z'
        stroke='#FFFFFF'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
};

export default Connect;
